var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fae8735dbad66b7fe3168d70675cc79d85a68300"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cube-front@rac"]={id:"fae8735dbad66b7fe3168d70675cc79d85a68300"};
      